const getCustomToken = () => {
  return localStorage.getItem("customToken") || null;
};

export { getCustomToken };
